import { render } from "./Tem004.vue?vue&type=template&id=74c40aa1&scoped=true"
import script from "./Tem004.vue?vue&type=script&lang=js"
export * from "./Tem004.vue?vue&type=script&lang=js"

import "./Tem004.vue?vue&type=style&index=0&id=74c40aa1&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74c40aa1"]])

export default __exports__